module.exports = __webpack_public_path__ + "img/buttonTrue_pressed.d76a4472.png";